/**
 * 偵測「有新版本」—— 防止**用戶卡喺舊 bundle**（P1.5-E；2026-09-28 事故後加）
 *
 * 為何要（真實事故）：產品負責人「撳咗冇反應」→ 查 audit log 完全冇請求 → 原來部機
 *   （手機加到主畫面之後**只係切返出嚟**，頁面冇 reload）仍然跑住**修 bug 之前**嘅 JS。
 *   ⭐ 部署咗新版本唔等於用戶用緊新版本 —— 要有**機制**話佢知，唔係靠佢自己撞。
 *
 * 做法（零依賴、唔用版本號服務器）：每 `intervalMs` ＋ 每次頁面重新可見 →
 *   用 `cache: 'no-store'` 拎一次 `index.html`，睇 `assets/index-*.js` 嘅檔名有冇變
 *   （Vite 每次 build 都換 hash → 檔名一變就係新版本）
 *
 * ⚠️ 唔自動 reload（唔想打斷用戶填表單）→ 只回一個 flag，由 UI 彈提示畀用戶自己撳。
 */
import { useEffect, useState } from 'react';

export function useNewVersion(intervalMs = 60_000): boolean {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    // 而家跑緊嘅 bundle 檔名（例 `index-BIBo_V5f.js`）
    const current =
      document.querySelector<HTMLScriptElement>('script[src*="/assets/index-"]')?.src.split('/').pop() ?? '';
    if (!current) return;

    let stopped = false;
    const check = async () => {
      try {
        const res = await fetch('/', { cache: 'no-store' });
        const html = await res.text();
        const hit = html.match(/assets\/index-[A-Za-z0-9_-]+\.js/);
        if (!stopped && hit && !hit[0].endsWith(current)) setStale(true);
      } catch {
        /* 離線／網絡問題 → 唔理（下一次再試） */
      }
    };

    const timer = setInterval(() => void check(), intervalMs);
    const onVisible = () => {
      if (document.visibilityState === 'visible') void check();
    };
    document.addEventListener('visibilitychange', onVisible);
    void check();

    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);

  return stale;
}
